// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1XWtj","options":"AnswerScale_options__3ihvP","selected":"AnswerScale_selected__Jc9aN"};